import React, { useState, useEffect } from "react";
import {
  Card,
  CardTitle,
  CardBody,
  Row,
  Col,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import { URL } from "../../api";
import axiosInstance from "../../Request";

const Credit = ({ cid, lid, bureau_data }) => {
  const [bureauReportModal, setBureauReportModal] = useState(false);
  const [bureauData, setBureauData] = useState(null);
  const [loading, setLoading] = useState(false);

  const [fetchCibilModal, setFetchCibilModal] = useState(false);
  const [commentText, setCommentText] = useState("");
  const [selectedSource, setSelectedSource] = useState("Cibil");

  const [latestScore, setLatestScore] = useState({
    value: bureau_data?.score ?? "Pending",
    color: bureau_data?.score ? "green" : "red",
    bureau: bureau_data?.bureau_type ?? null,
  });

  useEffect(() => {
    setLatestScore({
      value: bureau_data?.score ?? "Pending",
      color: bureau_data?.score ? "green" : "red",
      bureau: bureau_data?.bureau_type ?? null,
    });
  }, [bureau_data]);

  const fetchBureauReports = async () => {
    if (!cid || !lid) return;

    setLoading(true);
    try {
      const response = await axiosInstance.get(
        `${URL.BUREAU_REPORTS}?customer_id=${cid}&lead_id=${lid}`
      );
      const data = response.data;
      setBureauData(data);

      // Determine latest score
      if (Array.isArray(data) && data.length > 0) {
        const today = new Date();
        let closestReport = null;
        let closestDiff = Infinity;

        data.forEach((report) => {
          if (report.create_date) {
            const reportDate = new Date(report.create_date);
            const diff = today - reportDate;
            if (diff >= 0 && diff < closestDiff) {
              closestDiff = diff;
              closestReport = report;
            }
          }
        });

        if (closestReport?.score != null) {
          setLatestScore({
            value: closestReport.score,
            color: "green",
            bureau: closestReport.bureau_type,
          });
        } else {
          setLatestScore({
            value: "No Score",
            color: "red",
            bureau: null,
          });
        }
      } else {
        setLatestScore({
          value: "No Score",
          color: "red",
          bureau: null,
        });
      }
    } catch (error) {
      console.error("Failed to fetch bureau reports:", error);
      setBureauData(null);
      setLatestScore({
        value: "No Score",
        color: "red",
        bureau: null,
      });
    }
    setLoading(false);
  };

  const toggleBureauReportModal = () => {
    const shouldOpen = !bureauReportModal;
    setBureauReportModal(shouldOpen);
    if (shouldOpen) fetchBureauReports();
  };

  const toggleFetchCibilModal = () => {
    setFetchCibilModal(!fetchCibilModal);
  };

  const handleFetchCibilSubmit = async () => {
    const userId = localStorage.getItem("user_id");

    if (!commentText.trim() || !selectedSource) {
      alert("Please enter a comment and select a bureau type.");
      return;
    }

    if (!userId) {
      alert("User ID not found in local storage.");
      return;
    }

    let applicationId = null;
    if (Array.isArray(bureauData)) {
      const found = bureauData.find(
        (item) =>
          item.bureau_type?.toLowerCase() === selectedSource.toLowerCase() &&
          item.applicationid
      );
      if (found) applicationId = found.applicationid;
    } else if (bureauData?.application_id) {
      applicationId = bureauData.application_id;
    }
 

    const url = `${URL.BUREAU_FETCH}?customer_id=${cid}&user_id=${userId}&comment=${encodeURIComponent(
      commentText
    )}&bureauType=${selectedSource}`;

    try {
      const response = await axiosInstance.get(url);
      if (response.status !== 200) {
        throw new Error(response.statusText || "Unknown error");
      }
     } catch (error) {
      console.error("Error calling fetch bureau API:", error);
     }

    setCommentText("");
    setSelectedSource("Cibil");
    setFetchCibilModal(false);
  };

  // ✅ Handle View Button
  const handleViewClick = async (reportId) => {
    try {
      const response = await axiosInstance.get(
        `${URL.BUREAU_REPORTSVIEW}?customerId=${cid}&report_id=${reportId}`
      );

      const htmlContent = response.data;
      if (htmlContent) {

        const width = Math.floor(window.innerWidth * 0.9);
        const height = Math.floor(window.innerHeight * 0.9);

        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;

        const popup = window.open(
          "",
          "_blank",
          `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`
        );

        if (popup) {
          popup.document.write(htmlContent);
          popup.document.close();
        } else {
          alert("Popup blocked. Please allow popups for this site.");
        }
      } else {
        alert("No report content found.");
      }
    } catch (error) {
      console.error("Error viewing bureau report:", error);
      alert("Failed to open report.");
    }
  };


  return (
    <>
      <Col xs="6" sm="4" md="3">
        <Card className="card-stats mb-4">
          <CardBody>
            <Row>
              <div className="col">
                <CardTitle tag="h5" className="text-uppercase text-muted mb-0">
                  Bureau Reports
                </CardTitle>
                <button
                  type="button"
                  className="clickable btn btn-link p-0"
                  onClick={toggleBureauReportModal}
                  title=""
  style={{ outline: "none", boxShadow: "none" }}
                >
                  <span
                    className="h2 font-weight-bold mb-0"
                    style={{ color: latestScore.color }}
                  >
                    {loading ? "Loading..." : latestScore.value}{" "}
                    {latestScore.bureau && `(${latestScore.bureau})`}
                  </span>
                </button>
              </div>
            </Row>
          </CardBody>
        </Card>
      </Col>

      {/* Bureau Reports Modal */}
      <Modal
        id="bureauReportsModal"
        isOpen={bureauReportModal}
        toggle={toggleBureauReportModal}
        size="lg"
      >
        <ModalHeader toggle={toggleBureauReportModal}>
          Bureau Reports
        </ModalHeader>
        <ModalBody>
          <div className="mb-3">
            <Button color="info" onClick={toggleFetchCibilModal}>
              Fetch Bureau
            </Button>
          </div>

          {loading ? (
            <span>Loading...</span>
          ) : bureauData ? (
            Array.isArray(bureauData) ? (
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th>Lead Id</th>
                    <th>Bureau</th>
                    <th>Create Date</th>
                    <th>Score</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {bureauData.length > 0 ? (
                    bureauData.map((item, index) => (
                      <tr key={index}>
                        <td>{item.leadid || "N/A"}</td>
                        <td>{item.bureau_type}</td>
                        <td>
                          {item.create_date
                            ? new Date(item.create_date).toLocaleDateString()
                            : "N/A"}
                        </td>
                        <td>
                          {item.score !== null ? (
                            <span style={{ color: "green" }}>{item.score}</span>
                          ) : (
                            <span style={{ color: "red" }}>No Score</span>
                          )}
                        </td>
                        <td>
                          <Button
                            color="primary"
                            size="sm"
                            onClick={() => handleViewClick(item.id)}
                          >
                            View
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center" style={{ color: "red" }}>
                        No bureau reports found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            ) : (
              <div>
                <p>
                  Application ID:{" "}
                  <b>{bureauData.application_id || bureauData.applicationid}</b>
                </p>
                <p>{bureauData.message || "No detailed bureau report available."}</p>
              </div>
            )
          ) : (
            <p style={{ color: "red" }}>No bureau reports found.</p>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleBureauReportModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

      {/* Fetch Cibil Modal */}
      <Modal isOpen={fetchCibilModal} toggle={toggleFetchCibilModal}>
        <ModalHeader toggle={toggleFetchCibilModal}>
          Fetch Bureau Report
        </ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label>Comment</label>
            <textarea
              className="form-control"
              rows="3"
              value={commentText}
              onChange={(e) => setCommentText(e.target.value)}
              placeholder="Write your comment here"
            ></textarea>
          </div>
          <div className="form-group mt-3">
            <label>Select Bureau</label>
            <select
              className="form-control"
              value={selectedSource}
              onChange={(e) => setSelectedSource(e.target.value)}
            >
              <option value="Experian">Experian</option>
              <option value="Equiafax">Equiafax</option>
              <option value="Crif">Crif</option>
              <option value="Cibil">Cibil</option>
            </select>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleFetchCibilSubmit}>
            Submit
          </Button>
          <Button color="secondary" onClick={toggleFetchCibilModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Credit;